import { useEffect, useRef, useState } from "react";

import FnrButtonPopper from "UI/FnrButtonPopper";
import FnrContainedIcon from "UI/FnrContainedIcon";

import {
  useIsHovered,
  useIsFocusVisible,
} from "Utilities/Hooks/useIsHoverFocused";

import ButtonSizer from "../ButtonSizer";
import PopperButton from "../PopperButton";
import { hoverTextKeys, useHoverTextKey } from "../accountAndSettingsStore";

import LogoutPopperContent from "./LogoutPopperContent";

const LogoutButton = () => {
  const [closeTrigger, setCloseTrigger] = useState({});
  const buttonRef = useRef();
  const [, setHoverTextKey] = useHoverTextKey();
  const isHovered = useIsHovered(buttonRef);
  const isFocusVisible = useIsFocusVisible(buttonRef);

  useEffect(() => {
    if (isHovered || isFocusVisible) setHoverTextKey(hoverTextKeys.logout);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHovered, isFocusVisible, setHoverTextKey]);

  return (
    <FnrButtonPopper
      ref={buttonRef}
      content={<LogoutPopperContent setCloseTrigger={setCloseTrigger} />}
      Button={PopperButton}
      buttonProps={{
        "aria-label": "logout",
      }}
      closeTrigger={closeTrigger}
      autoFocus
      style={{ borderRadius: 22 }}
    >
      <ButtonSizer>
        <FnrContainedIcon
          noPadding
          color="textLight"
          icon="right-from-bracket fas"
        />
      </ButtonSizer>
    </FnrButtonPopper>
  );
};

export default LogoutButton;
